export default {"src":"/_next/static/media/0xa478c2975ab1ea89e8196811f51a7b7ade33eb11.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};